import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const FormBuilder = () => (
  <ComponentDocs
    name="<FormBuilder/>"
    entry="FormBuilder"
    propsEntry="FormBuilderProps"
  >
    <ComponentExample
      name="Submit form"
      import={import("examples/Builders/FormBuilder/SubmitFormExample")}
      rawImport={import("examples/Builders/FormBuilder/SubmitFormExample?raw")}
    />
    <ComponentExample
      name="Load data then submit"
      import={import("examples/Builders/FormBuilder/LoadDataThenSubmitExample")}
      rawImport={import(
        "examples/Builders/FormBuilder/LoadDataThenSubmitExample?raw"
      )}
    />
    <ComponentExample
      name="Load and submit params"
      import={import(
        "examples/Builders/FormBuilder/LoadAndSubmitParamsExample"
      )}
      rawImport={import(
        "examples/Builders/FormBuilder/LoadAndSubmitParamsExample?raw"
      )}
    />
    <ComponentExample
      name="Controlled form builder"
      description="Due to the way that form data is communicated via React context, controlled form builders are only suitable for simple forms. When using form triggers either use an uncontrolled builder or manually connect a form without the builder. Alternatively use the onApplyChanges prop to apply the changes to the state directly."
      import={import(
        "examples/Builders/FormBuilder/ControlledFormBuilderExample"
      )}
      rawImport={import(
        "examples/Builders/FormBuilder/ControlledFormBuilderExample?raw"
      )}
    />
    <ComponentExample
      name="Read Only"
      description="A form builder can switch between read-only and editing states to restrict the ability to edit. Most form components support a renderReadOnly prop to allow the read-only view to be customised."
      import={import("examples/Builders/FormBuilder/ReadOnlyFormExample")}
      rawImport={import(
        "examples/Builders/FormBuilder/ReadOnlyFormExample?raw"
      )}
    />
    <ComponentExample
      name="Dirty Forms"
      description="A form builder can track whether any changes have been made to a form. Use the isDirtyChange prop to customise whether a form change should mark the form as 'dirty'."
      import={import("examples/Builders/FormBuilder/DirtyFormsExample")}
      rawImport={import("examples/Builders/FormBuilder/DirtyFormsExample?raw")}
    />
    <ComponentExample
      name="Auto Save"
      import={import("examples/Builders/FormBuilder/AutoSaveFormExample")}
      rawImport={import(
        "examples/Builders/FormBuilder/AutoSaveFormExample?raw"
      )}
    />
    <ComponentExample
      name="Abort submitting"
      import={import("examples/Builders/FormBuilder/AbortSubmittingExample")}
      rawImport={import(
        "examples/Builders/FormBuilder/AbortSubmittingExample?raw"
      )}
    />
  </ComponentDocs>
);

export default FormBuilder;
